import { create } from "zustand";

export const useEstadisticasStore = create((set) => ({
    estadisticas: null,
    infracciones: null,
    vehiculos: null,
    general: null,
    abonadas: null,

    setEstadisticas: (estadisticas) => {
        set({ estadisticas: estadisticas });
    },

    setInfracciones: (infracciones) => {
        set({ infracciones: infracciones })
    },

    setVehiculos: (vehiculos) => {
        set({ vehiculos: vehiculos })
    },

    setGeneral: (estadisticas) => {
        set({ general: estadisticas })
    },
    setAbonadas: (estadisticas) => {
        set({ abonadas: estadisticas })
    }
}))
